import React from 'react';

const Settings = () => <div>settings</div>;

export default Settings;
